import React from 'react';
import { MultiSelect, Text } from '@usealloy/component-library';
import { Controller, useFormContext } from 'react-hook-form';
import type { Option } from '@usealloy/component-library';
import type { FormState } from './types';
import { getServiceFailureDefaultOptions, getTagLocalSettingsFieldElementId } from './helpers';
import {
  StyledTagLocalFormContainer,
  StyledLeftColumnContainer,
} from './styles';
import type { NodeEditorAutoSaveTabProps } from '../useNodeEditorForm/types';
import { useAppSelector } from '~/store/reduxHooks';
import { selectDiffMode, selectWorkflowFailureHandlingMode } from 'flow/store/redux/selectors';
import { failureHandlingDescriptionBestEffortMode, failureHandlingDescriptionFullThresholdMode } from '../constants';
import { getDiffStyleFunction, PLACEHOLDER_DIFF_STATUS } from '../diffStyles';
import { StyledWorkflowHistoryField } from '../styles';
import { createFormCommitHandler } from '../useNodeEditorForm';


export default function TagLocalSettingsTab({
  handleAutoSave: onAutoSave,
  isReadOnly,
}: NodeEditorAutoSaveTabProps) {
  const {
    control,
    handleSubmit,
  } = useFormContext<FormState>();
  const failureHandlingModeValue = useAppSelector(selectWorkflowFailureHandlingMode);
  const isInDiffMode = useAppSelector(selectDiffMode);

  // TODO: hardcoded until the per-field diff status is wired in. The diff-mode guard is
  // redundant once that lookup returns null outside diff mode, and can be dropped then.
  const diffStatus = isInDiffMode ? PLACEHOLDER_DIFF_STATUS : null;

  const serviceFailureOptions = React.useMemo(() => getServiceFailureDefaultOptions(), []);
  const commitForm = createFormCommitHandler<FormState>(onAutoSave);

  const handlingDescription = failureHandlingModeValue === 'full-threshold'
    ? failureHandlingDescriptionFullThresholdMode : failureHandlingDescriptionBestEffortMode;

  return (
    <StyledTagLocalFormContainer>
      <StyledLeftColumnContainer>
        <StyledWorkflowHistoryField
          id={getTagLocalSettingsFieldElementId('serviceFailureDefaultOption')}
        >
          <Controller
            name="serviceFailureDefaultOption"
            control={control}
            render={({ field: { onChange, value } }) => (
              <>
                <MultiSelect
                  isMulti={false}
                  label="Service Failure Handling - if data is missing:"
                  onChange={(newValue: Option) => {
                    onChange(newValue);
                    handleSubmit(commitForm('serviceFailureDefaultOption'))();
                  }}
                  options={serviceFailureOptions}
                  selectedOptions={value}
                  isDisabled={isReadOnly}
                  customStyleFunctions={getDiffStyleFunction(diffStatus)}
                />
                <Text as="span" size={2} style={{ color: 'var(--cl-text-secondary)' }}>
                  {handlingDescription}
                </Text>
              </>
            )}
          />
        </StyledWorkflowHistoryField>
      </StyledLeftColumnContainer>
    </StyledTagLocalFormContainer>
  );
}
